import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchComments(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/comments', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchComment(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/comment/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateComment(ctx, { id, formData }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/comment/${id}/update`, formData)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteComment(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/comment/${id}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}